import { Injectable, TemplateRef } from '@angular/core';
import { BehaviorSubject, interval } from 'rxjs';
import { debounce } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class TopNavService {
  // private readonly _userDrawerOpened$ = new BehaviorSubject(false);
  // userDrawerState$ = this._userDrawerOpened$.asObservable();

  private readonly _template$ =
    new BehaviorSubject<TemplateRef<unknown> | null>(null);
  attachedTemplate$ = this._template$.asObservable();

  private readonly loading$ = new BehaviorSubject<boolean>(false);
  isLoading$ = this.loading$.pipe(
    debounce((state) => interval(state ? 2000 : 0))
  );
  //
  // openUserDrawer(): void {
  //   this._userDrawerOpened$.next(true);
  // }

  // closeUserDrawer(): void {
  //   this._userDrawerOpened$.next(false);
  // }

  attachTemplate(template: TemplateRef<unknown> | null): void {
    this._template$.next(template);
  }

  setLoadingSate(state: boolean): void {
    this.loading$.next(state);
  }
}
